const MAIN_MENU_ITEMS = [
  {
    id: 'design_get_started',
    path: '/design/get_started',
    component: 'DesignGetStartedIntroduction'
  },
  {
    id: 'design_foundations',
    path: '/design/foundations',
    component: 'DesignFoundationsTypography'
  },
  {
    id: 'design_components',
    path: '/design/components',
    component: 'DesignComponentsBadge'
  }
].map(e => ({ ...e, type: 'main_menu' }));

const SUB_MENU_ITEMS = [
  {
    id: 'design_get_started_introduction',
    path: '/design/get_started/introduction',
    parentId: 'design_get_started'
  },
  {
    id: 'design_get_started_principles',
    path: '/design/get_started/principles',
    parentId: 'design_get_started'
  },
  {
    id: 'design_foundations_typography',
    path: '/design/foundations/typography',
    parentId: 'design_foundations'
  },
  {
    id: 'design_foundations_color',
    path: '/design/foundations/color',
    parentId: 'design_foundations'
  },
  {
    id: 'design_foundations_iconography',
    path: '/design/foundations/iconography',
    parentId: 'design_foundations'
  },
  {
    id: 'design_foundations_spacing',
    path: '/design/foundations/spacing',
    parentId: 'design_foundations'
  },
  {
    id: 'design_foundations_motion',
    path: '/design/foundations/motion',
    parentId: 'design_foundations'
  },
  {
    id: 'design_foundations_writings',
    path: '/design/foundations/writings',
    parentId: 'design_foundations'
  },
  {
    id: 'design_components_badge',
    path: '/design/components/badge',
    parentId: 'design_components'
  },
  {
    id: 'design_components_button',
    path: '/design/components/button',
    parentId: 'design_components'
  },
  {
    id: 'design_components_control',
    path: '/design/components/control',
    parentId: 'design_components'
  },
  {
    id: 'design_components_dropdown',
    path: '/design/components/dropdown',
    parentId: 'design_components'
  },
  {
    id: 'design_components_form',
    path: '/design/components/form',
    parentId: 'design_components'
  },
  {
    id: 'design_components_header',
    path: '/design/components/header',
    parentId: 'design_components'
  },
  {
    id: 'design_components_modal',
    path: '/design/components/modal',
    parentId: 'design_components'
  },
  {
    id: 'design_components_pagination',
    path: '/design/components/pagination',
    parentId: 'design_components'
  },
  {
    id: 'design_components_product_data',
    path: '/design/components/product_data',
    parentId: 'design_components'
  },
  {
    id: 'design_components_review_data',
    path: '/design/components/review_data',
    parentId: 'design_components'
  },
  {
    id: 'design_components_thumbnail',
    path: '/design/components/thumbnail',
    parentId: 'design_components'
  }
].map(e => ({ ...e, type: 'sub_menu' }));

export default [
  {
    id: 'design_home',
    path: '/design/home',
    component: 'DesignHome',
    type: 'home'
  },
  ...MAIN_MENU_ITEMS,
  ...SUB_MENU_ITEMS
];
